import { Common } from './common';
import { EmCode } from './models/emCode';

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findAllByEncounterId(
    encounterId: string,
  ): Promise<{ emCodes: EmCode[] }> {
    const url = this.common.constructPath(`/encounter/${encounterId}/em-codes`);
    return this.common.getJSON(url);
  }
}
